import React from 'react'
import { Wrapper, Filler } from './components/Styled'
import { useStoreView } from '../../hooks/useStoreView'

interface Props {
  totalCount?: number
  currentItem?: number
  percentage?: number
}
export const ProgressBar: React.FC<Props> = ({ totalCount = 0, currentItem = 0, percentage }) => {
  const percentageCalc = percentage ?? currentItem * 100 / totalCount
  const { isSofiaAndGrace } = useStoreView()
  return (
    <Wrapper isSofiaAndGrace={isSofiaAndGrace}>
      <Filler
        width={percentageCalc}
        isSofiaAndGrace={isSofiaAndGrace}
      />
    </Wrapper>
  )
}
